import React, {useState} from 'react';
import {ConfirmModal} from '@/components/common/confirmationModal';
import {ReturnPolicyModal} from '@/components/common/ReturnPolicyModal';

type CancelConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [isReturnPolicyModalOpen, setIsReturnPolicyModalOpen] = useState(false);

  const handleRefundPolicyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsReturnPolicyModalOpen(true);
  };

  if (!isOpen) return null;

  return (
    <>
      <ConfirmModal
        open={isOpen}
        onClose={onClose}
        onConfirm={onConfirm}
        showCloseIcon={true}
        header={'Are you sure you want to cancel\nthis consultation?'}
        subMessage={
          <>
            Cancellation will apply according to the{' '}
            <a
              href="#"
              onClick={handleRefundPolicyClick}
              className="underline text-ui_input_border_dark font-FigtreeMedium cursor-pointer hover:text-ui_blue">
              refund policy
            </a>
          </>
        }
        cancelButtonText="Cancel"
        confirmButtonText="Yes"
      />
      <ReturnPolicyModal
        isOpen={isReturnPolicyModalOpen}
        onClose={() => setIsReturnPolicyModalOpen(false)}
      />
    </>
  );
};

export default CancelConfirmationModal;
